export default {"src":"/_next/static/media/businessMoreSocialMedia.9bc138c0.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};